
export const skills = [
   {
    title:"Modern UI & UX Design",
    image: "./course69.svg",
   
   },
   {
    title:"Responsive Web Design/Development",
    image: "./course75.svg"
   },
   {
    title:"Secured Web Hosting",
    image: "./course77.svg"
   },
   {
  
    title:"Web Maintainance",
    image: "./course79.svg"
   }
  
  ];
  export const myAbout = [
    {
      // contentThree: "I'm From Africa,Live in Nigeria 🇳🇬,I Speaks Hausa & English.",
      content: "I'm a Certified Responsive Web developer, Frontend & Backend.",
      contentTwo: "I Like reading, exploring new awesome ideas & collaborating on exciting projects and Devs."
    }
  ];
  export const projects = [
    {
      title: "React Reserve",
      subtitle: "MERN Stack",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-1.png",
      link: "https://reactbootcamp.com",
    },
    {
      title: "React Tracks",
      subtitle: "React and Python",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./hero-image-3-small.webp",
      link: "https://reactbootcamp.com",
    },
    {
      title: "DevChat",
      subtitle: "React and Firebase",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./2.webp",
      link: "https://reactbootcamp.com",
    },
    {
      title: "Epic Todo App",
      subtitle: "React Hooks",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./3.png",
      link: "https://reactbootcamp.com",
    },
  ];
 